export default __webpack_public_path__ + "static/media/ic_peru.7c0976a0.svg";